<template>
  <div
    :data-id="page.id"
    id="page"
    v-shortkey="['meta', 'c']"
    @shortkey="copyContent();"
    :class="{ copied: copied }"
  >
    <!-- Notification on copy -->
    <div class="toast" @click="copied = '';">Copied to clipboard!</div>

    <div class="note">
      <textarea
        @input="updateTextarea"
        id="input"
        v-autosize="input"
        v-model="input"
        autofocus
      >
        {{ input }}</textarea
      >
      <div id="output" class="output">
        <div class="item" v-for="(line, index) in output" :key="index">
          <a
            href="#"
            title="Click to copy value"
            v-clipboard:copy="line"
            v-clipboard:success="copySuccess"
            v-clipboard:error="copyError"
            >{{ line }}
          </a>
        </div>
      </div>
      <prism language="javascript" class="sh-input">{{ inputTemp }}</prism>
    </div>

    <div class="options">
      <!--
        <div class="left">
          <select v-model="page.currency">
            <option v-for="currency in supportedCurrencies">{{ currency }}</option>
          </select>
        </div>
      -->
      <div class="right">
        <button
          class="button button-share"
          v-clipboard:copy="rawOutput"
          v-clipboard:success="copySuccess"
          v-clipboard:error="copyError"
          title="Click to copy everything"
        >
          Copy all
        </button>
      </div>
    </div>
  </div>
</template>

<script>
// localStorage persistence
const STORAGE_KEY = 'tinysums';
const CURRENCY_KEY = STORAGE_KEY + '_currencies';
const debounce = require('lodash.debounce');

import Peg from '../parser.js';
import PrismJS from '../prism.min.js';
import Prism from 'vue-prism-component';

export default {
  name: 'page',
  data: function() {
    return {
      page: {
        id: 0,
        title: '',
        currencySymbol: '$',
        currency: 'AUD'
      },
      input:
        '// Define values to use in calculations\r\ndays = 15\r\n\r\n// Define some variables\r\nfood: $12 * days\r\ntransport: $3.50 * days\r\n\r\n// Add up all the above\r\nsum\r\n\r\n// Use units like kg\r\n20kg plus 1900g\r\n\r\n// Quickly calculate percentages\r\n32% off $429\r\n\r\n// Or compound interest\r\n$4000.22 at 3% pa\r\n\r\n// Dates, currency and more\r\ntoday',
      inputTemp: '',
      currencies: '',
      supportedCurrencies: [
        'AUD',
        'USD',
        'CAD',
        'GBP',
        'EUR',
        'JPY',
        'THB',
        'HKD',
        'NZD',
        'CHF',
        'MXN',
        'CNY'
      ],
      // Full list
      //supportedCurrencies: ['AUD', 'BGN', 'BRL', 'CAD', 'CNY', 'DKK', 'GBP', 'HKD', 'HRK', 'HUF', 'IDR', 'ILS', 'INR', 'JPY', 'KRW', 'MXN', 'MYR', 'NOK', 'NZD', 'PHP', 'PLN', 'RON', 'RUB', 'SEK', 'SGD', 'THB', 'TRY', 'USD', 'ZAR', 'EUR'],
      output: [],
      rawOutput: [],
      store: [],
      copied: ''
    };
  },
  components: {
    Peg,
    Prism
  },
  created: function() {
    const data = this.fetchData(this.page.id);
    if (data) {
      this.page.id = data.id;
      this.input = data.input;
      this.rawOutput = data.rawOutput;
    }
    this.output = this.parseText(this.input);
    this.currencies = this.populateCurrencies();
    this.inputTemp = this.input;
  },
  updated: function() {},
  watch: {
    // For updating Prism highlight
    input: function(val, oldVal) {
      this.inputTemp = val;
    }
  },
  computed: {},

  methods: {
    updateTextarea: debounce(function(e) {
      this.input = e.target.value;
      this.input = e.target.value;
      this.output = this.parseText(this.input);
      this.generateRawOutput(this.output);
      this.saveData();
    }, 300),
    parseText(input) {
      var output = this.output;

      try {
        var parsed = Peg.parse(input);

        var i,
          output = [];

        for (i = 0; i < parsed.length; i++) {
          //console.log('type:" + parsed[i].type);
          if (
            parsed[i].type == 'comment' ||
            parsed[i].type == 'blank' ||
            parsed[i].type == 'words' ||
            parsed[i].value == ''
          ) {
            output.push('\n');
          } else {
            var line = parsed[i].value;

            if (typeof line === 'object') {
              var prefix = line.prefix ? line.prefix : '';
              var suffix = line.suffix ? line.suffix : '';
              line = line.value;
            } else if (line) {
              var prefix = parsed[i].prefix ? parsed[i].prefix : '';
              var suffix = parsed[i].suffix ? parsed[i].suffix : '';
            }

            output.push(this.constructLine(line, prefix, suffix));
          }
        }

        return output;
      } catch (err) {
        console.log(err);
      }
      return output;
    },

    constructLine(line, prefix, suffix) {
      if (suffix != 'currency') {
        if (prefix) {
          line = this.formatNumber(line, prefix);
        } else if (!isNaN(line)) {
          line = this.formatNumber(line, '', 0);
        }
      } else {
        if (prefix.toUpperCase() != this.page.currency) {
          var index = this.supportedCurrencies.indexOf(prefix.toUpperCase());
          if (index != -1) {
            var convertedVal = this.formatNumber(
              parseFloat(line) /
                this.currencies.rates[this.supportedCurrencies[index]],
              ''
            );
            line = this.page.currency + this.page.currencySymbol + convertedVal;
          }
        } else {
          line = this.formatNumber(line, '$', 2);
        }
      }

      if (!prefix && suffix) {
        line = line + suffix;
      }
      return line;
    },
    formatNumber(n, prefix, c, d, t) {
      // Format currency
      // n = number
      // c = decimal places
      // d = decimal point
      // t = thousand separator
      var c = isNaN((c = Math.abs(c))) ? 2 : c,
        d = d == undefined ? '.' : d,
        t = t == undefined ? ',' : t,
        prefix = prefix == undefined ? '$' : prefix,
        s = n < 0 ? '-' : '',
        i = String(parseInt((n = Math.abs(Number(n) || 0).toFixed(c)))),
        j = (j = i.length) > 3 ? j % 3 : 0;

      return (
        prefix +
        s +
        (j ? i.substr(0, j) + t : '') +
        i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + t) +
        (c
          ? d +
            Math.abs(n - i)
              .toFixed(c)
              .slice(2)
          : '')
      );
    },
    saveData: function() {
      //console.log('Save')

      if (this.input) {
        const saveData = {
          id: this.page.id,
          input: this.input,
          rawOutput: this.rawOutput
        };

        if (this.store[this.page.id]) {
          this.store[this.page.id] = saveData;
        } else {
          // A new board so push add it to the store array
          this.store.push(saveData);
        }

        // Save as stringified array
        localStorage.setItem(STORAGE_KEY, JSON.stringify(this.store));
      }
    },
    fetchData: function() {
      // Get the stored data from a cookie
      this.store = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      return this.store[0];
    },
    generateRawOutput(outputArray) {
      var inputArray = this.input.split('\n');
      var output = '';

      for (var i = 0; i < inputArray.length; ++i) {
        if (outputArray[i]) {
          if (outputArray[i] == '\n') {
            output += '\n';
          } else {
            output += inputArray[i] + ' = ' + outputArray[i] + '\n';
          }
        }
      }
      this.rawOutput = output;
      return output;
    },
    constructOutput: function() {
      // Loop through this.sorted and serialize content
      const parsedSections = this.parsedSections;
      var output = '',
        sorted = this.sorted;

      sorted.forEach(function(ref, i) {
        output += parsedSections[ref.i].options[ref.j].content;
      });

      return output;
    },
    copyContent: function(e) {
      // Copy the contents of textarea
      //this.$copyText(this.rawOutput).then(function (e) {
      //  this.copySuccess()
      //})
    },
    copySuccess: function() {
      // Show toast for a second
      console.log('Copied content');
      var copied = this.copied;
      this.copied = 'copied';
      setTimeout(() => (this.copied = ''), 1200);
    },
    copyError(e) {
      console.log('Copy error');
    },
    copyItem(e) {
      console.log('Copy item');
    },
    populateCurrencies: function() {
      // Check for cookie
      console.log('Populate currencies');
      var currencies,
        storedCurrencies = JSON.parse(localStorage.getItem(CURRENCY_KEY));
      console.log(storedCurrencies);
      // If cookie doesn't exist then fetch latest currency data
      if (!storedCurrencies) {
        currencies = this.fetchCurrencies();
      } else {
        // Check the timestamp and update once per day
        var now = Math.round(new Date().getTime() / 1000);
        if (storedCurrencies.timestamp < now - 24 * 3600) {
          console.log('Older than a day so overwrite cookie');
          currencies = this.fetchCurrencies();
        } else {
          console.log('Data from cookie');
          currencies = storedCurrencies.data;
        }
      }
      return currencies;
    },
    fetchCurrencies: function() {
      var currencies = this.axios
        .get('https://api.exchangeratesapi.io/latest?base=AUD')
        .then(response => {
          return response.data;
        });
      // Used for testing
      var currencies = {
        rates: {
          PHP: 37.4710400403,
          HUF: 203.2233694284,
          IDR: 10158.1843364392,
          TRY: 3.9209267187,
          RON: 2.9483127676,
          ISK: 87.1946612944,
          ILS: 2.6378745908,
          CNY: 4.8621254092,
          USD: 0.7192143037,
          EUR: 0.6295643415,
          PLN: 2.702719718,
          GBP: 0.560469655,
          CAD: 0.9540418031,
          AUD: 1.0,
          MYR: 2.9441576429,
          NZD: 1.054960967,
          CHF: 0.7092671871,
          HRK: 4.675459582,
          SGD: 0.974187862,
          DKK: 4.6989423319,
          BGN: 1.2313019391,
          CZK: 16.0992193402,
          BRL: 2.6674641148,
          JPY: 78.0785696298,
          KRW: 807.8947368421,
          INR: 51.1401410224,
          SEK: 6.446927726,
          MXN: 13.6813774868,
          RUB: 48.2700831025,
          HKD: 5.640518761,
          ZAR: 9.9393729539,
          THB: 22.9432132964,
          NOK: 6.1454923193
        },
        base: 'AUD',
        date: '2019-01-15'
      };
      var now = Math.round(new Date().getTime() / 1000);
      // Set a cookie with this value
      localStorage.setItem(
        CURRENCY_KEY,
        JSON.stringify({ timestamp: now, data: currencies })
      );
      return currencies;
    }
  },
  filters: {
    pluralise: function(n) {
      return n === 1 ? 'item' : 'items';
    }
  },
  directives: {
    'text-focus': function(el, value) {
      if (value) el.focus();
    }
  }
};
</script>

<style lang="sass">
@import "../assets/scss/_variables.scss";

.note {
  max-width: 720px;
  min-height: 200px;
  //max-width: 100%;
  margin: 0 auto;
  position: relative;
}

header {
  padding: $base-padding*2 $base-padding;

  h2 {
    color: #fafafa;
    margin: 0;
    font-size: $font-size-medium;
    font-weight: 800;
    text-transform: uppercase;
    background-color: $color-teal;
    border-radius: 2px;
    padding: 5px 8px;
    padding-top: 7px;
    line-height: 1;
    display: inline-block;
    float: left;
    margin-top: -5px;

    em {
      font-weight: 400;
      font-style: normal;
    }
  }

  small {
    color: $color-light-text;
    font-size: 0.875em;
    display: inline-block;
    margin-left: 0;
  }
}

textarea {
  margin: 0;
  border: 0;
  height: inherit;
  width: 100%;
  min-height: calc(100vh - 125px);
  background-color: transparent;
  font-color: transparent;
  outline: none;
  resize: none;
  z-index: 1;
  opacity: 0.4;
  outline: none;
  color: #000;
}

textarea,
.output,
.sh-input {
  font-family: 'Montserrat', sans-serif;
  font-size: 1em;
  line-height: 1.5;
  text-align: left;
  padding: $base-padding;
  padding-top: 0;
}

textarea,
.sh-input {
  white-space: pre-wrap;
  word-wrap: break-word;
}

.output {
  position: absolute;
  width: 30%;
  top: 0;
  right: 0;
  border-left: 1px solid #ddd;
  color: $color-teal;
  height: inherit;
}

.sh-input {
  position: absolute;
  top: 0;
  left: 0;
  margin: 0;
  pointer-events: none;
  overflow-y: auto;
  z-index: 3;

  code {
    font-size: inherit;
    font-family: inherit;
    color: inherit;
    display: block;
  }
}

.item {
  white-space: nowrap;
  display: block;
  width: 100%;

  a {
    white-space: nowrap;
    text-decoration: none;
    display: inline-block;
    padding: 0 $base-padding/2;
    border-radius: 30px;
    transition: all 0.15s $transition;
    position: relative;

    /*&:before {
      display: block;
      content: 'Copy value';
      position: absolute;
      bottom: 30px;
      color: #fff;
      background-color: rgba(0,0,0,0.7);
      padding: $base-padding/2 $base-padding;
      line-height: 1.2;
      border-radius: 5px;
      font-size: 0.7em;
      z-index: 99;
      visibility: hidden;
      opacity: 0;
      pointer-events: none;
      transition: all 0.15s $transition;
      transform: translate3d(0,5px,0);
    }*/

    &:hover {
      color: #fff;
      background-color: $color-teal;

      &:before {
        visibility: visible;
        opacity: 1;
        transform: translate3d(0,0,0);
      }
    }

    &:focus {
      outline: none;
    }

    &:active {
      background-color: darken($color-teal, 10%)
    }
  }
}

.options {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: $base-padding*2;


  select {
    border: 1px solid #ddd;
    padding: 12px;
  }
}

.right { float: right }
.left { float: left }


.ios {
  .sh-input code {
    padding-left: 3px
  }
}

// Show confirmation at top of screen when copied
.toast {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  font-weight: bold;
  text-align: center;
  z-index: 99;
  background-color: $color-green;
  color: #fff;
  padding: $base-padding;
  transition: transform .15s $transition;
  transform: translate3d(0,-50px,0);
  transform-origin: top center;
}

.copied {
  .toast { transform: translate3d(0,0,0) }
}


@media (min-width: 560px) {
  header {
    padding: $base-padding*2;
  }

  textarea,
  .output,
  .sh-input {
    font-size: 1.2em;
    line-height: 1.5;
    padding: $base-padding*2;
  }
}
</style>



// WEBPACK FOOTER //
// Page.vue?a3b99bb0